import parsePoint from '../../../shared/parsePoint';
import {
    DXFParserSnippet,
    Identity,
    ToBoolean
} from '../../../shared/parserGenerator';
import CommonBoundaryPathDataSnippets from './shared';

const PolylineSnippets: DXFParserSnippet[] = [
    ...CommonBoundaryPathDataSnippets,
    {
        code: 10,
        name: 'vertices',
        parser(current, scanner) {
            const vertex = { ...parsePoint(scanner), bulge: 0 };

            const next = scanner.next();
            if (next.code === 42) {
                if (typeof next.value === 'number') {
                    vertex.bulge = next.value;
                }
            } else {
                scanner.rewind();
            }

            return vertex;
        },
        isMultiple: true,
    },
    {
        code: 93,
        name: 'numberOfVertices',
        parser: Identity,
    },
    {
        code: 73,
        name: 'isClosed',
        parser: ToBoolean,
    },
    {
        code: 72,
        name: 'hasBulge',
        parser: ToBoolean,
    },
];

export default PolylineSnippets;
